module.exports = __webpack_public_path__ + "55ff070631f41fdf1065eb988f04271f.png";